// extracted by mini-css-extract-plugin
export var backgroundImageInnerWrapper = "landing-carousel-module--background-image-inner-wrapper--2BlXx";
export var backgroundImageOuterWrapper = "landing-carousel-module--background-image-outer-wrapper--nynfY";
export var carouselItem = "landing-carousel-module--carousel-item--HHpv9";
export var textWrapper = "landing-carousel-module--text-wrapper--3cMjU";
export var wrapper = "landing-carousel-module--wrapper--V70qb";